var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"margin":"15px"},attrs:{"src":_vm.leagueInfos.flag}}),_c('span',[_vm._v(_vm._s(_vm.leagueInfos.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }